import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { SearchFilterModel } from '@app/core/models/search-filter.model';
import * as _ from 'lodash';
import { TableNavigationModel } from '@app/shared/models/table-navigation.model';
import { ImportMissingInvoiceNumberDataSource } from '@app/core/models/imports/import-missing-invoice-number-data-source.model';
import { ImportService } from '@app/core/services/import.service';
import { ImportMissingInvoiceNumberDocumentSearchCriteriaModel } from '@app/core/models/imports/import-missing-invoice-number-searchcriteria.model';

@Injectable({ providedIn: 'root' })
export class MissingInvoiceNumberSearchResolver  {
  constructor(private importService: ImportService,
    private sessionStorageService: SessionStorageService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<ImportMissingInvoiceNumberDataSource> | Promise<ImportMissingInvoiceNumberDataSource> | ImportMissingInvoiceNumberDataSource {

    const searchFilterKey = route.data.searchFilterKey;
    const searchFilter = this.sessionStorageService.get<SearchFilterModel<ImportMissingInvoiceNumberDocumentSearchCriteriaModel>>(searchFilterKey);
    const pageNavigation = Object.assign({}, JSON.parse(localStorage.getItem('table_config_missingInvoiceNumberSearch'))?.pageDef) as TableNavigationModel;
    const defaultPageSize = 20;
    const pageSort = pageNavigation.Sort?.active;
    const pageSortDirection = pageNavigation.Sort?.direction;
    const pageNumber = searchFilter?.Page ?? 0;
    const pageSize = pageNavigation.Page?.pageSize ?? defaultPageSize;

    return this.importService.searchMissingInvoiceNumberDocuments(pageSort, pageSortDirection, pageNumber, pageSize, searchFilter?.Filter).pipe(catchError(this.handleError));
  }

  private handleError(err: HttpErrorResponse | any) {
    console.error('An error occurred', err);
    return throwError(err.message || err);
  }
}
